import { createWebHistory, createRouter } from "vue-router";
import Home from "@/views/Home.vue";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/ministracoes",
        name: "Preachings",
        component: () => import("@/views/Preachings.vue"),
    },
    {
        path: "/links",
        name: "Links",
        component: () => import("@/views/Links.vue"),
        meta: { hidden: true },
    },
    {
        path: "/design-system",
        name: "DesignSystem",
        component: () => import("@/views/DesignSystem.vue"),
        meta: { hidden: true },
    },
    {
        path: "/tribus",
        name: "Tribus",
        beforeEnter() {
            window.location.replace("https://conferenciatribus.com.br/");
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
